import script from "./PsaUploadFile.vue?vue&type=script&setup=true&lang=js"
export * from "./PsaUploadFile.vue?vue&type=script&setup=true&lang=js"

import "./PsaUploadFile.vue?vue&type=style&index=0&id=772c0510&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-772c0510"]])

export default __exports__